<script>
  export let id;
  export let email;
  export let subject;
  export let body;
  export let attached;
  export let beforeSend;
  export let onSent;

  import { post } from "../utils/api.js";
  import { sendEmail } from "../utils/email";

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe((value) => {
    dict = value;
  });

  let send = async () => {
    if (beforeSend) {
      beforeSend();
    }
    for (let i = 0; i < email.length; i++) {
      await sendEmail(email[i], subject, body, attached);
    }

    onSent();
  };
</script>

<style>
  textarea {
    width: 100%;
  }

  span.black {
    color: var(--revista-black);
  }

  p.lines {
    word-wrap: break-word;
  }
</style>

<div class="modal show" {id} tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{dict['enviarEmail']}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="lines">
          <span class="black">{dict['para']}:</span>
          {#each email as e}{e};&nbsp;{/each}
        </p>
        <p><span class="black">{dict['asunto']}:</span> {subject}</p>
        <p />
        <textarea rows="10" bind:value={body} />
        {#if attached.length > 0}
          <p class="lines">
            <span class="black">{dict['adjuntos']}:</span>
            {#each attached as a}{a.nombre};&nbsp;{/each}
          </p>
        {/if}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" on:click={() => send()}>
          {dict['enviarEmail']}
        </button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {dict['cancelar']}
        </button>
      </div>
    </div>
  </div>
</div>
